var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"creator-service-tag d-center px-3"},[_c('span',[_vm._v(_vm._s(_vm.item.icon))]),_vm._v(" "),_c('span',{staticClass:"gradient-text"},[_vm._v(_vm._s(_vm.item.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }